import { SandhillsSlickSlider, Panel } from '@Components/Shared/SandhillsSlickSlider';
import { useWindowSize } from '@Components/Utilities/WindowSize';

const Backlinks = (props) => {
	const windowSize = useWindowSize();

	const sliderSettings = {
		dots: true,
		slidesToShow: 6,
		slidesToScroll: 6,
		adaptiveHeight: true,
		infinite: true,
		autoplay: true,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					arrows: false,
					autoplaySpeed: 5000,
					slidesToShow: 4.675,
					slidesToScroll: 4,
				}
			},
			{
				breakpoint: 768,
				settings: {
					arrows: false,
					autoplaySpeed: 5000,
					slidesToShow: 3.675,
					slidesToScroll: 3,
				}
			},
			{
				breakpoint: 480,
				settings: {
					arrows: false,
					autoplaySpeed: 5000,
					slidesToShow: 2.675,
					slidesToScroll: 2,
				}
			}
		]
	};

	const cards = [...props?.Cards];

	if (cards && cards.length > 0 && windowSize.isMobile) {
		const lastCard = cards.pop();
        cards.unshift(lastCard);
	}

	return (cards && cards.length > 0 && 
		<SandhillsSlickSlider ShowSection settings={sliderSettings} {...props}>
			{cards.map((backlink, index) =>
				<Panel key={`brand-slider-${backlink.Url}`} id={`family-brands-${index}`} PanelType={"panel"} PanelClass={props.PanelClass} OpenInNewTab {...backlink} />)}
		</SandhillsSlickSlider>
    );
}

export default Backlinks;